import { useState } from "react";
import { Steps, Button, message, Row, Col, Tabs } from "antd";
import { stepsConfig } from "./StepConfig";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { FormIcon } from "../../../Icons/FormIcon";
import { Header } from "../../../components/Header";
import "./style.scss";
import { BackArrow } from "../../../Icons/BackArrow";
import { useNavigate, useParams } from "react-router-dom";
import { useDeleteData } from "../../../Network/useDeleteData";
import { DeleteConfirmation } from "./DeleteModal";
import { useGetData } from "../../../Network/useGetQueryData";
import TabPane from "antd/es/tabs/TabPane";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { UserRolesId } from "../../enum";

const { Step } = Steps;

const AddProvidersSteps = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state: any) => state.user.user);
  const stepNum = useQueryParams("step");
  const { id } = useParams();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState<number>(+stepNum || 0);
  const [isDeleteView, setIsDeleteView] = useState<boolean>();
  const [deleteLoading, setDeleteLoading] = useState<boolean>();
  const CurrentStepComponent = stepsConfig[currentStep].component;
  const handleNext = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const { data } = useGetData<{
    data: any;
  }>({
    queryKey: ["service-provider-details"],
    url: `service-provider/${id}`,
    options: {
      enabled: !!id,
      queryKey: ["service-provider-details"],
    },
  });

  const { mutate: deleteItem } = useDeleteData({
    url: `service-provider/${id}`,
    options: {
      onSuccess: () => {
        message.success(t("messages.deleteSuccess"));
        setDeleteLoading(false);
        navigate("/providers");
      },
      onError: (error) => {
        setDeleteLoading(false);
        message.error(t("messages.deleteError"));
        console.error("Failed to delete item:", error);
      },
    },
  });

  const handlePrevious = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleSaveAndClose = () => {
    navigate("/providers");
  };

  const handleStepClick = async (step: number) => {
    if (currentStep === 0 && !id) return;
    setCurrentStep(step);
  };

  const handleDeleteProvider = () => {
    setDeleteLoading(true);
    try {
      deleteItem();
    } catch (error) {
      setDeleteLoading(false);
    }
  };

  return (
    <div>
      <Header
        title={t("header.providers")}
        backIcon={
          <span
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/providers")}
          >
            <BackArrow />
          </span>
        }
      />
      <div
        className={`add-provider-header provider-edit ${id ? "edit-view" : ""} ${
          id && userInfo?.roleId === UserRolesId.Admin ? "admin-view" : ""
        }`}
      >
        <h2>{t("form.addProvider")}</h2>

        {id ? (
          <Tabs
            activeKey={String(currentStep)}
            onChange={(key) => setCurrentStep(+key)}
          >
            {stepsConfig.map((item, index) => (
              <TabPane tab={item.title} key={index} />
            ))}
          </Tabs>
        ) : (
          <Steps
            labelPlacement="vertical"
            current={currentStep}
            onChange={handleStepClick}
          >
            {stepsConfig.map((item, index) => (
              <Step key={index} title={item.title} />
            ))}
          </Steps>
        )}
        {id && userInfo?.roleId !== UserRolesId.Provider && (
          <Button
            onClick={() => setIsDeleteView(true)}
            className="delete-btn"
            type="link"
          >
            {t("actions.delete")}
          </Button>
        )}
      </div>
      <div className="steps-container">
        <Row gutter={30}>
          <Col lg={24} xl={16}>
            <div className="step-wrapper-component">
              <CurrentStepComponent onChangeStep={setCurrentStep} />
            </div>
            {currentStep > 0 && (
              <div className="steps-action-footer">
                {currentStep < stepsConfig.length - 1 && (
                  <Button type="primary" onClick={handleNext}>
                    {t("actions.next")}
                  </Button>
                )}
                {currentStep === stepsConfig.length - 1 && (
                  <Button
                    type="primary"
                    onClick={() => message.success(t("messages.formSubmitted"))}
                  >
                    {t("actions.submit")}
                  </Button>
                )}
                <Button
                  type="link"
                  style={{ marginLeft: 8 }}
                  onClick={handleSaveAndClose}
                >
                  {t("actions.saveAndClose")}
                </Button>
              </div>
            )}
          </Col>
          <Col lg={24} xl={8}>
            <div className="form-icon-text">
              <FormIcon />
              <p>{t("form.saveReminder")}</p>
            </div>
          </Col>
        </Row>

        {isDeleteView && (
          <DeleteConfirmation
            onCloseModal={() => setIsDeleteView(false)}
            provider={data?.data}
            onDelete={handleDeleteProvider}
          />
        )}
      </div>
    </div>
  );
};

export default AddProvidersSteps;
